import { DatePicker } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldDatePicker = ({ value, onChange, ...props }) => {
  let parsedValue = null;
  
  if (value) {
    // Si ya es un objeto Moment válido
    if (moment.isMoment(value) && value.isValid()) {
      parsedValue = value;
    }
    // Si es un string o Date válido
    else if (typeof value === 'string' || value instanceof Date) {
      const m = moment(value);
      if (m.isValid()) parsedValue = m;
    }
  }
  
  return <DatePicker value={parsedValue} onChange={(date) => onChange?.(date ? date.toISOString() : null)} {...props} className="w-full"/>;
};

DynamicFieldDatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldDatePicker);
